import { ref } from 'vue'
import { defineStore } from 'pinia'

export enum ModalType {
  Information,
  Confirmation,
  Error,
  Input
}

export enum ActionTakenType {
  Confirm,
  Cancel,
  None
}

export interface ModalData {
  message?: string | null
  tableMessage?: any | null
  header: string
  confirmButtonText: string
  confirmButtonFunction?: (data: ModalData) => void
  cancelButtonFunction?: (data: ModalData) => void
  cancelButtonText?: string | null
  uuid?: string | null
  actionTaken?: ActionTakenType | null
  type: ModalType
  component?: any | null
  componentProps?: Record<string, any> | null
  linkToPdf?: string | null
  inputValue?: string | null
  modalWidth?: string | null
  autoClose?: boolean
  hideActions?: boolean
}

export const useModalControlStore = defineStore('modalControl', () => {
  const showModalInner = ref(false)
  const showModalOuter = ref(false)
  const modalQueue = ref<ModalData[]>([])

  const modalData = ref<ModalData>({
    message: 'default message goes here',
    header: 'Default Header',
    confirmButtonText: 'Ok',
    confirmButtonFunction: (data: ModalData) => {},
    cancelButtonFunction: (data: ModalData) => {},
    cancelButtonText: 'Cancel',
    uuid: Math.random().toString(36).substring(7),
    actionTaken: ActionTakenType.None,
    type: ModalType.Information,
    component: null,
    componentProps: {},
    linkToPdf: null,
    inputValue: null,
    autoClose: false,
    hideActions: false
  })

  const openModal = () => {
    showModalInner.value = true
    showModalOuter.value = true

    if (modalData.value.autoClose) {
      setTimeout(() => {
        closeModal()
      }, 3000)
    }
  }
  const closeModal = () => {
    showModalInner.value = false

    setTimeout(() => (showModalOuter.value = false), 500)
    setTimeout(() => (showModalInner.value = true), 525)

    setTimeout(() => {
      if (modalQueue.value.length > 0) {
        modalData.value = modalQueue.value.shift()!
        openModal()
      } else {
        showModalOuter.value = false
        showModalInner.value = false
      }
    }, 550)
  }

  return {
    showModalInner,
    showModalOuter,
    modalQueue,
    modalData,
    openModal,
    closeModal
  }
})

export function launchModal(data: ModalData) {
  const store = useModalControlStore()

  // Generate a random uuid for the modal
  data.uuid = Math.random().toString(36).substring(7)
  data.actionTaken = ActionTakenType.None

  if (store.showModalOuter) {
    store.modalQueue.push(data)
  } else {
    store.modalData = data
    store.openModal()
  }

  return data.uuid
}
